import axios from 'axios'
import Swiper from 'swiper/bundle'
import 'swiper/swiper-bundle.css'
import moment from 'moment'

import svgIconArrowLeft from '../../icons/icon-arrow-left.svg'
import svgIconArrowRight from '../../icons/icon-arrow-right.svg'

export default class Schedule {
	static init() {
		const block = document.querySelector('.program-content')
		if (block) {
			new Schedule(block)
		}
	}

	constructor(block) {
		this.block = block

		this.daysItems = [...block.querySelectorAll('.program-date-carousel .carousel-item')]

		this.initSwiper()
		this.bindEvents()
		this.setSvg(this.block)

		const day = block.querySelector('.program-date-carousel .carousel-item.active').dataset.date
		this.loadDaySchedule(day, this.putScheduleList, this.handleError)
	}

	initSwiper() {
		new Swiper('.program-date-carousel .swiper-container', {
			initialSlide: 7,
			slidesPerView: 4,
			breakpoints: {
				762: {
					slidesPerView: 7,
				},
			},
			navigation: {
				nextEl: '.program-date-carousel .swiper-button-next',
				prevEl: '.program-date-carousel .swiper-button-prev',
			},
		})
	}

	setSvg(block) {
		const iconArrowLeft = block.querySelectorAll('.icon-arrow-left')
		const iconArrowRight = block.querySelectorAll('.icon-arrow-right')

		if (iconArrowLeft) {
			iconArrowLeft.forEach((icon) => {
				icon.insertAdjacentHTML('afterbegin', svgIconArrowLeft)
			})
		}

		if (iconArrowRight) {
			iconArrowRight.forEach((icon) => {
				icon.insertAdjacentHTML('afterbegin', svgIconArrowRight)
			})
		}
	}

	bindEvents() {
		this.onDateClick()
	}

	onTelecastClick() {
		const telecastItems = document.querySelectorAll('.js-accordion-link')

		telecastItems.forEach((item) =>
			item.addEventListener('click', (e) => {
				e.preventDefault()
				let itemActive = item.parentNode.classList.contains('active')
				item.parentNode.classList.remove('active')
				if (!itemActive) {
					item.parentNode.classList.add('active')
				}
			})
		)
	}

	onDateClick() {
		this.daysItems.forEach((dayItem) =>
			dayItem.addEventListener('click', (event) => {
				event.preventDefault()

				this.daysItems.forEach((d) => {
					d.classList.remove('active')
				})

				dayItem.classList.add('active')

				const day = dayItem.dataset.date

				this.loadDaySchedule(day, this.putScheduleList, this.handleError)
			})
		)
	}

	putScheduleList(data) {
		const timeToDate = (time) => {
			const chunks = time.split(':')
			let date = new Date()
			date.setHours(Number(chunks[0]))
			date.setMinutes(Number(chunks[1]))

			return date
		}

		let container = document.querySelector('.js-schedule-list')
		container.innerHTML = ''

		let items = []
		data.forEach(function (item) {
			let template = document.querySelector('.js-list-template').cloneNode(true)
			let content = template.querySelector('.item-content')

			content.querySelector('.image').style.backgroundImage = `url('${item.telecast.imagePreview}')`

			let projectText = template.querySelector('.project-text')
			projectText.innerHTML = item.telecast.description

			let itemTime = template.querySelector('.item-time')
			itemTime.innerHTML = item.time

			let itemTitle = template.querySelector('.item-title')
			itemTitle.innerHTML = item.telecast.title
			if (item.telecast.ageRating !== undefined && item.telecast.ageRating > 0) {
				itemTitle.innerHTML = itemTitle.innerHTML + ` (${item.telecast.ageRating}+)`
			}

			items.push(template.firstElementChild)
		})

		items.forEach((el) => container.appendChild(el))
	}

	handleError() {
		let container = document.querySelector('.js-schedule-list')
		container.innerHTML = ''
		let template = document.querySelector('.js-list-template').firstElementChild.cloneNode(true)
		template.innerHTML = 'Программа на этот день ещё не загружена'
		container.appendChild(template)
	}

	loadDaySchedule(date, templateHandler, errorHandler) {
		axios
			.post(`/schedule/${date}`)
			.then((r) => {
				const {
					data: { schedule },
				} = r
				templateHandler(schedule)
				this.onTelecastClick()
			})
			.catch(function (error) {
				console.log(error)
				errorHandler()
			})
	}
}
